import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Button from './Button';
import { useTranslation } from 'react-i18next';

interface UploadConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const UploadConfirmationModal: React.FC<UploadConfirmationModalProps> = ({ isOpen, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4"
          onClick={onCancel} // Omogućava zatvaranje klikom na pozadinu
          aria-modal="true"
          role="dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <motion.div
            className="bg-white rounded-lg shadow-xl p-6 md:p-8 w-full max-w-lg m-4"
            onClick={e => e.stopPropagation()} // Sprečava zatvaranje pri kliku unutar modala
            initial={{ opacity: 0, scale: 0.95, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
          >
            <h2 className="text-xl font-bold text-slate-800 mb-4">{t('upload_modal.title')}</h2>
            <p className="text-slate-600 mb-6 text-sm">
              {t('upload_modal.description_part1')}
              <br /><br />
              {t('upload_modal.description_part2')}
              <a href={t('helperMenu.termsOfUseLink')} target="_blank" rel="noopener noreferrer" className="text-sky-600 underline hover:text-sky-800">{t('upload_modal.terms_of_service')}</a> {t('upload_modal.and')}
              <a href={t('helperMenu.privacyPolicyLink')} target="_blank" rel="noopener noreferrer" className="text-sky-600 underline hover:text-sky-800">{t('upload_modal.privacy_policy')}</a>.
            </p>
            <div className="flex justify-end gap-4">
              <Button onClick={onCancel} variant="secondary">
                {t('upload_modal.cancel_button')}
              </Button>
              <Button onClick={onConfirm} variant="primary">
                {t('upload_modal.confirm_button')}
              </Button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default UploadConfirmationModal;